<template>
    <div>
        <college-banner></college-banner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row padd-top-10">
                        <div class="col-md-12" v-if="requested_applications.length">
                            <div class="col-md-4 col-sm-6" v-for="rj in requested_applications">
                                <router-link :to="{path: '/detail?id=' + rj.slug}" data-aos="fade-zoom-in" class="cp-com-box">
                                    <div class="cp-com-logo">
                                        <router-link :to="{path: '/profile?slug=' + rj.org_slug}"><img v-bind:src="rj.logo" alt=""></router-link>
                                    </div>
                                    <div class="jb-com-name">
                                        <router-link :to="{path: '/profile?slug=' + rj.org_slug}" v-html="rj.name"></router-link>
                                    </div>
                                    <div class="cp-com-category">
                                        {{rj.title}}
                                    </div>
                                  <span class="stamp is-nope" v-if="rj.is_closed">Recruitment Completed</span>
                                    <div class="cp-com-opper">
                                        Location : <span>{{rj.location}}</span>
                                    </div>
                                    <div class="cp-com-opper">
                                        Positions : <span>{{rj.positions}}</span>
                                    </div>
                                    <div class="cp-com-opper">
                                        <router-link :to="{path: '/detail?id=' + rj.slug}">View Detail</router-link>
                                    </div>
                                    <div class="cp-view-btn cp-blank-actions" v-if="!rj.is_closed">
                                        <a href="javascript:;" @click.prevent="accept($event)" :data-key="rj.application_enc_id" :data-id="rj.org_enc_id">Accept</a>
                                        <a href="javascript:;" @click.prevent="reject($event)" :data-key="rj.application_enc_id" class="default">Reject</a>
                                    </div>
                                  <div class="cp-blank-actions" v-else></div>
                                </router-link>
                            </div>
                        </div>
                        <div class="col-md-12 text-center" v-else>
                            <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                            <h2 class="no-data-found">No Requested Applications Found</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import collegeBanner from './../../components/collegeBanner.vue'
    import CollegeSideNavLayout from './../../components/CollegeSideNavLayout.vue'
    import axios from 'axios';
    import toastr from  '../../../public/js/toastr.js';
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner
        },
        data(){
            return {
                requested_applications:'',
            }
        },
        mounted(){
            this.getApplications();
        },
        methods: {
            accept: function (event) {
                var t = this;
                var element = event.currentTarget;
                var data_key = element.getAttribute('data-key');
                function getUrlVars() {
                    var vars = {};
                    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                        vars[key] = value;
                    });
                    return vars;
                }
                var url = this.$store.getters.getDomain;
                var data = 'Accept';
                var type = getUrlVars()["type"];

                if(type == 'jobs' || type == 'internships'){
                    var data_id = element.getAttribute('data-id');
                    axios.post(`${url}api/v2/college-index/job-approve`, {application_enc_id: data_key, org_enc_id: data_id, action:data}, {
                        headers: requestHeaders()
                    }).then(function (response) {
                        if(response['data']['response']['status'] == 200){
                            if(type == 'jobs'){
                                toastr.success('Job Approved Successfully', 'Success');
                            } else {
                                toastr.success('Internship Approved Successfully', 'Success');
                            }
                            t.getApplications();
                        } else {
                            toastr.error('An error occurred try again later.', 'Error');
                        }
                    })
                }
            },
            reject: function (event) {
                var t = this;
                var element = event.currentTarget
                var data_key = element.getAttribute('data-key');
                var url = this.$store.getters.getDomain;
                function getUrlVars() {
                    var vars = {};
                    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                        vars[key] = value;
                    });
                    return vars;
                }
                var type = getUrlVars()["type"];
                var data = 'Reject';
                if(type == 'jobs' || type == 'internships'){
                    axios.post(`${url}api/v2/college-index/job-approve`, {application_enc_id: data_key, action:data}, {
                        headers: requestHeaders()
                    }).then(function (response) {
                        if(response['data']['response']['status'] == 200){
                            if(type == 'jobs'){
                                toastr.success('Job Rejected Successfully', 'Success');
                            } else {
                                toastr.success('Internship Rejected Successfully', 'Success');
                            }
                            t.getApplications();
                        } else {
                            toastr.error('An error occurred try again later.', 'Error');
                        }
                    })
                }
            },
            getApplications(){
                var t = this;
                var url = this.$store.getters.getDomain;
                function getUrlVars() {
                    var vars = {};
                    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                        vars[key] = value;
                    });
                    return vars;
                }
                function sentenceCase (str) {
                    return str.replace(/[a-z]/i, function (letter) {

                        return letter.toUpperCase();

                    }).trim();
                }
                var data = getUrlVars()["type"];
                data = sentenceCase(data);

                axios.post(`${url}api/v2/college-index/jobs-selection`, {type:data}, {headers: requestHeaders()}).then(function (response) {
                    t.requested_applications = response['data']['response']['jobs'];
                });
            },
        }
    }
</script>

<style scoped>
    .cp-com-opper{
        position: relative;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 32px;
    }
</style>